<rt-icon
  *ngIf="notificationStyle === NotificationStyle.Error"
  name="warning"
  [color]="IconColor.White"
></rt-icon>

<div *ngIf="notificationStyle === NotificationStyle.Success" class="success">
  <rt-icon name="check" [color]="IconColor.Green"></rt-icon>
</div>

<div *ngIf="notificationStyle === NotificationStyle.InProgress" class="progress">
  <rt-spinner variant="small-x"></rt-spinner>
</div>
